"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerLocationFormatter = void 0;
class LoggerLocationFormatter {
    static start(className, methodName) {
        return `${className}>>${methodName}>>start`;
    }
    static step(className, methodName, stepName) {
        return `${className}>>${methodName}>>${stepName || 'unknown-step'}`;
    }
    static end(className, methodName) {
        return `${className}>>${methodName}>>end`;
    }
    static error(className, methodName) {
        return `${className}>>${methodName}>>error`;
    }
}
exports.LoggerLocationFormatter = LoggerLocationFormatter;
//# sourceMappingURL=logger-location-formatter.js.map